<script setup lang="ts">
import ResultValue from './ResultValue.vue'

interface Props {
  homeResult?: number | string | null
  awayResult?: number | string | null
}

defineProps<Props>()
</script>

<template>
  <ResultValue
    :class="{
      'text-current-team-home-5': homeResult !== undefined,
    }"
    :result="homeResult"
  />

  <span class="px-1.5">:</span>
  <ResultValue
    :class="{
      'text-current-team-away-5': awayResult !== undefined,
    }"
    :result="awayResult"
  />
</template>
